// removed by extract-text-webpack-plugin
module.exports = {"mediaQueries":"\"styles/shared/breakpoints.css\"","ie10":"(-ms-high-contrast: active) and (-ms-high-contrast: none)","dndTable":"dndTable__dndTable___2gApL layout__otrp_card___3A8Sf","dndTablePackage":"dndTable__dndTablePackage___1eOiM dndTable__dndTable___2gApL layout__otrp_card___3A8Sf print__ot_print-new-page___2yLWk","bucketList":"dndTable__bucketList___26eGD","list":"dndTable__list___1XUnP","listItem":"dndTable__listItem___12XWh","printHidden":"dndTable__printHidden___dd25Q print__printHidden___3GLMT","printTotals":"dndTable__printTotals___t_4mt","totalTitle":"dndTable__totalTitle___3Wnzj"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/tables/dnd/dndTable.css
// module id = 1448
// module chunks = 0